import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REST_SERVER_HOST } from '@schoolbelle/api/tokens';
import { identity, mapValues, pickBy } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class VirtualAccountService {

  constructor(
    private http:HttpClient,
    @Inject(REST_SERVER_HOST) private serverHost
  ) {
  }
  // '003', // 기업은행
  // '004', // 국민은행 
  // '005', // KEB하나은행
  // '011', // 농협중앙회 (세틀뱅크 테스트 계정에서만 9999오류 발생)
  // '020', // 우리은행
  // '023', // SC제일은행
  // '027', // 한국씨티은행
  // '031', // 대구은행
  // '039', // 경남은행
  // '032', // 부산은행
  // '034', // 광주은행
  // '071', // 정보통신부 우체국
  // '088', // 신한은행 (세틀뱅크 테스트 계정에서만 9999오류 발생)   
  getPossibleBanks () {
    const url = `${this.serverHost}/purchase/transaction/vbank/banks`;
    return this.http.get<{name:string, code:string}[]>(url);
  }

  getVirtualAccount (params:{uuid:string}) {
    const url = `${this.serverHost}/purchase/transaction/vbank`;
    let httpParams = new HttpParams({
      fromObject: mapValues(pickBy(params, identity), v => '' + v)
    });

    return this.http.get(url, { params:httpParams });
  }

  createVirtualAccount(params:{uuid:string, vbank_code:string, vbank_due?:number}) {
    if (!params.vbank_due) params.vbank_due = Date.now() + 30 * 24 * 60 * 60 * 1000;
    const url = `${this.serverHost}/purchase/transaction/vbank`;
    return this.http.post(url, params);
  }
}
